package com.dotpx.ambient

/** App-specific playback policy around the library's platform outputs. */
internal interface ControllerAudioPolicy {
    val outputGain: Float get() = 1f
    val fadeInOnStart: Boolean get() = false
    val closeOnPause: Boolean get() = false
    val supportsContinuousEngine: Boolean get() = false

    fun render(callback: (FloatArray, Int) -> Unit, buffer: FloatArray, frameCount: Int) = callback(buffer, frameCount)
}

internal object DefaultControllerAudioPolicy : ControllerAudioPolicy

internal expect fun platformControllerAudioPolicy(): ControllerAudioPolicy
